export interface ProyectoPorUsuario{
    iddecinvproyecto: number,
    nombrerol: string,
    cedula: string,
    nombrecolaborador: string,
    email: string,
    tituloproyecto: string,
    tipoproyecto: string,
    idunidad?: number,
    fechainicio?: Date,
    fechafin?: Date,
    meses: number
}

export function getVoidProyectoPorUsuario():ProyectoPorUsuario{
    return {
    iddecinvproyecto: 0,
    nombrerol: "",
    cedula: "",
    nombrecolaborador: "",
    email: "",
    tituloproyecto: "",
    tipoproyecto: "",
    idunidad: 0,
    meses: 0
   }
}

export interface ReporteProyectoPorUsuario{
    archivoExcel: string,
    listaproyectos: Array<ProyectoPorUsuario>,
}